module.exports = __webpack_public_path__ + "assets/angular.6e21cea2.svg";